import { CurrencyCode } from "consts";

import {
  AccountingMethodology,
  PracticeBundle,
  PracticeFCPO,
  PracticeFertilizerApplication,
  PracticeFertilizerMineral,
  PracticeFertilizerOrganic,
  PracticeSlug,
  RequirementLevel,
  VerificationEditingRequest,
  WithInjectedName,
} from "models";

import { PracticeConfigForBulk } from "pages/app/all-field-view/utils/BulkDataEntryUtils.ts";
import { InputRequirementConfig } from "pages/app/all-field-view/utils/getInputRequirementConfig";

export type FertilizersResponse = {
  applications: Array<WithInjectedName<PracticeFertilizerApplication>>;
  mineral: Array<WithInjectedName<PracticeFertilizerMineral>>;
  organic: Array<WithInjectedName<PracticeFertilizerOrganic>>;
};

export const FERTILIZER_TYPE = {
  ORGANIC: "organic",
  MINERAL: "mineral",
} as const;

export type FertilizerType = (typeof FERTILIZER_TYPE)[keyof typeof FERTILIZER_TYPE];

export type OrganicAndMineralFertilizersProps = {
  // bulk flows pass a tag naming which of the selected crops an entry belongs to; nothing renders without it
  renderEntryTag?: (practice: FertilizerApplication) => React.ReactNode;
  // forwarded so bulk flows can rename an entry that does not exist on any crop yet
  renderEntryTitle?: (practice: FertilizerApplication) => React.ReactNode;
  // locks every input of every entry, whatever its own verification state allows — for a caller that may not write to it at all
  isReadOnly?: boolean;
  chosenFertilizerType: FertilizerType;
  disabled: boolean;
  existingFertilizers: PracticeFCPO[];
  baselineYears: number[] | undefined;
  recommendedSeedingDate?: string;
  year: number;
  practiceBundle?: PracticeBundle;
  currency?: CurrencyCode;
  requirementLevel?: RequirementLevel;
  requirementConfig?: InputRequirementConfig | null;
  practiceConfigForBulk?: PracticeConfigForBulk;
  onBundleActivation?: (bundleSlug: PracticeSlug, value: boolean) => Promise<void>;
  bulkEditMode?: boolean;
  carbonProgramMethodology?: AccountingMethodology;
  fieldIsEnrolled?: boolean;
  // not offered in bulk edit flows; those callers simply omit these
  editingRequests?: VerificationEditingRequest[];
  isSubmissionFeatureEnabled?: boolean;
  farmId?: string;
};

export type FertilizerApplication = {
  key?: string;
} & PracticeFCPO;

export type PayoutOption = {
  label: string;
  value: boolean;
  payout: string;
};
